import type { IconSvgProps } from '../iconProps';

const ZipIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7929 2.5H6.75C6.47385 2.5 6.25 2.72385 6.25 3V22.5C6.25 22.7761 6.47385 23 6.75 23H21.25C21.5261 23 21.75 22.7761 21.75 22.5V7.4571C21.75 7.3245 21.6973 7.19732 21.6035 7.10355L17.1465 2.64645C17.0527 2.55268 16.9255 2.5 16.7929 2.5Z"
      fill="white"
      stroke="#FFC700"
      strokeMiterlimit="10"
    />
    <path
      d="M16.75 2.5V7C16.75 7.27615 16.9739 7.5 17.25 7.5H21.75"
      stroke="#FFC700"
      strokeMiterlimit="10"
    />
    <path
      d="M4 13.75H15.5C17.433 13.75 19 15.317 19 17.25C19 19.183 17.433 20.75 15.5 20.75H4V13.75Z"
      fill="#FFC700"
    />
    <path
      d="M8.0885 18.835H10.1105V19.375H7.3595V18.898L9.4145 15.487L9.4205 15.49H7.4945V14.95H10.1405V15.418L8.0885 18.826V18.835ZM10.8545 19.375V14.95H11.4965V19.375H10.8545ZM12.9701 19.375H12.3191V14.95H13.6511C13.9911 14.95 14.2761 15.014 14.5061 15.142C14.7381 15.27 14.9121 15.443 15.0281 15.661C15.1461 15.877 15.2051 16.119 15.2051 16.387C15.2051 16.655 15.1451 16.902 15.0251 17.128C14.9071 17.352 14.7321 17.532 14.5001 17.668C14.2681 17.804 13.9851 17.872 13.6511 17.872H12.9701V19.375ZM12.9701 17.65L12.6761 17.332H13.5761C13.7881 17.332 13.9661 17.294 14.1101 17.218C14.2561 17.14 14.3661 17.03 14.4401 16.888C14.5141 16.746 14.5511 16.579 14.5511 16.387C14.5511 16.195 14.5151 16.032 14.4431 15.898C14.3711 15.764 14.2631 15.663 14.1191 15.595C13.9751 15.525 13.7941 15.49 13.5761 15.49H12.6761L12.9701 15.148V17.65Z"
      fill="white"
    />
    <line x1="11.5" y1="2.75" x2="11.5" y2="9.75" stroke="#848484" />
    <rect
      x="10.5"
      y="10.25"
      width="2"
      height="2"
      rx="0.5"
      fill="#FFC700"
      stroke="#848484"
    />
    <path d="M11 4.25H10" stroke="#848484" strokeLinecap="round" />
    <path
      d="M13 4.75C13.2761 4.75 13.5 4.52614 13.5 4.25C13.5 3.97386 13.2761 3.75 13 3.75V4.25V4.75ZM13 4.25V3.75H12V4.25V4.75H13V4.25Z"
      fill="#848484"
    />
    <path d="M11 6.25H10" stroke="#848484" strokeLinecap="round" />
    <path
      d="M13 6.75C13.2761 6.75 13.5 6.52614 13.5 6.25C13.5 5.97386 13.2761 5.75 13 5.75V6.25V6.75ZM13 6.25V5.75H12V6.25V6.75H13V6.25Z"
      fill="#848484"
    />
    <path d="M11 8.25H10" stroke="#848484" strokeLinecap="round" />
    <path
      d="M13 8.75C13.2761 8.75 13.5 8.52614 13.5 8.25C13.5 7.97386 13.2761 7.75 13 7.75V8.25V8.75ZM13 8.25V7.75H12V8.25V8.75H13V8.25Z"
      fill="#848484"
    />
  </svg>
);

export default ZipIcon;
